// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1fppe","selects":"Documents_selects__yN4gh"};